module.exports = __webpack_public_path__ + "static/media/tournify-logo.fa4728b3.svg";